import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const generateUniqueOrderReference = async (): Promise<string> => {
  let isUnique = false;
  let orderReference = '';
  let attempts = 0;
  const maxAttempts = 10; // Prevent infinite loops
  
  while (!isUnique && attempts < maxAttempts) {
    attempts++;
    
    // Generate a random 6-digit number
    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    orderReference = `WD-${randomNumber}`;
    
    try {
      // Check if this reference already exists in the order_references collection
      const refDoc = doc(db, 'order_references', orderReference);
      console.log('Checking reference:', orderReference);
      
      const docSnapshot = await getDoc(refDoc);
      
      // If document doesn't exist, this reference is unique
      if (!docSnapshot.exists()) {
        console.log('Reference is unique, creating document...');
        // Reserve this reference by creating a document
        await setDoc(refDoc, {
          createdAt: new Date(),
          reserved: true
        });
        console.log('Reference reserved successfully');
        isUnique = true;
      } else {
        console.log('Reference already exists, trying another...');
      }
    } catch (error: any) {
      console.error('Error details:', {
        code: error.code,
        message: error.message,
        details: error.details,
        stack: error.stack
      });
      throw new Error('Failed to generate unique order reference');
    }
  }
  
  if (!isUnique) {
    throw new Error('Failed to generate unique order reference after maximum attempts');
  }
  
  return orderReference;
};